import * as Sentry from '@sentry/react'
import { AxiosError } from 'axios'

import instance from '@/services/request/interceptors.api'
import { request } from '@/services/request/request.api'

import keycloak from '@/auth/keycloak'
import {
	ITagInterfaceProps,
	TExternalSource,
	TLangCode,
	TPlatformsResponse
} from '@/types/uploadForm.interface'

export const CommonService = {
	async getTags(source: TExternalSource, lang: TLangCode) {
		const url = `/shotlists/tags/${source}/${lang}`
		const startedAt = performance.now()

		try {
			const response = await instance<ITagInterfaceProps>({
				url,
				method: 'GET'
			})

			const durationMs = performance.now() - startedAt
			const tagsCount = response.data?.tags?.length ?? 0

			if (!tagsCount) {
				Sentry.captureMessage('Empty tags response', {
					level: 'warning',
					tags: {
						feature: 'tags-request',
						source,
						lang,
						url
					},
					contexts: {
						tags_request: {
							url,
							source,
							lang,
							status: response.status,
							duration_ms: durationMs,
							requested_at: new Date().toISOString(),
							response: response.data,
							user_name: keycloak?.tokenParsed?.preferred_username,
							user_email: keycloak?.tokenParsed?.email
						}
					}
				})
			}

			return response.data
		} catch (error) {
			const durationMs = performance.now() - startedAt
			const axiosError = error as AxiosError

			Sentry.captureException(error, {
				tags: {
					feature: 'tags-request',
					source,
					lang,
					url,
					status: axiosError.response?.status
						? String(axiosError.response.status)
						: 'unknown'
				},
				contexts: {
					tags_request: {
						url,
						source,
						lang,
						status: axiosError.response?.status,
						duration_ms: durationMs,
						requested_at: new Date().toISOString(),
						response: axiosError.response?.data,
						user_name: keycloak?.tokenParsed?.preferred_username,
						user_email: keycloak?.tokenParsed?.email
					}
				}
			})

			throw error
		}
	},
	async getMetadata() {
		return request<{
			categories: Record<string, string>
			regiones: Record<string, Record<string, string>>
		}>({
			url: `/shotlists/meta`,
			method: 'GET'
		})
	},
	async getPlatforms() {
		const res = await request<TPlatformsResponse>({
			url: '/platforms',
			method: 'GET'
		})

		return res.platforms
	}
}
